import { CircleCheckBig } from "lucide-react";
import { type JSX, type ReactNode } from "react";

import { cn } from "@/lib/utils";

export enum MatchTagSize {
  Small = "sm",
  Large = "lg",
}

export type MatchTagVariant = "default" | "green";

const VARIANT_STYLES: Record<
  MatchTagVariant,
  { container: string; content: string }
> = {
  default: {
    container: "bg-card border border-brand-purple/40",
    content: "text-brand-purple",
  },
  green: {
    container: "bg-brand-teal-light",
    content: "text-timeline-action-to",
  },
};

export default function MatchTag({
  children,
  variant = "default",
  size,
}: {
  children: ReactNode;
  variant?: MatchTagVariant;
  size: MatchTagSize;
}): JSX.Element {
  const styles = VARIANT_STYLES[variant];
  const isLarge = size === MatchTagSize.Large;

  return (
    <div
      className={cn(
        "flex flex-row items-center px-1 py-[1px] gap-2 rounded-full h-6",
        isLarge && "sm:h-8 sm:gap-2.5 sm:px-2",
        styles.container,
      )}
    >
      <CircleCheckBig
        className={cn("h-4 w-4", isLarge && "sm:h-5 sm:w-5", styles.content)}
        aria-hidden="true"
      />
      <span
        className={cn(
          "font-semibold text-xs leading-[19px] pr-1.5",
          isLarge && "sm:text-sm",
          styles.content,
        )}
      >
        {children}
      </span>
    </div>
  );
}
